import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  AnimatedView,
  Panel,
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableCol
} from "../../components";
import Highlight from "react-highlight";
import { history } from "../../redux/store/configureStore";
import * as qs from "query-string";
import { Link } from "react-router-dom";
import Pagination from "react-js-pagination";
import { appConfig } from "../../config";
import {
  Button,
  FormGroup,
  InputGroup,
  FormControl,
  Alert,
  ButtonGroup,
  MenuItem,
  DropdownButton,
  Modal,
  ControlLabel,
} from "react-bootstrap";
import { createHashHistory } from "history";
import { Notification } from "../../components/notifications";
import { NewBreadcrumb as BreadcrumbComponent } from "../../components";
import auth from "../../services/auth";
import Switch from "react-switch";
import isEmpty from "lodash.isempty";
import Dialog from "react-bootstrap-dialog";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { withRouter } from "react-router-dom";
import { userList, userStatus} from "../../redux/actions/accessAction";
import { renderAlert, clearAlert } from "../../redux/actions/alertsActions";

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      no: 0,
      activePage: 1,
      msgType: "",
      alertMessage: "",
      search: "",
      limit: 15,
      direction: "",
      orderBy: "",
      sslList: [],
      toggleActive: true,
      total: 0,
      per_page: 10,
      from: 0,
      show: false,
      showDialog: false,
      path: ["Home", "SSL List"],
      links: ["home","/ssl/list"],
      sslshow: false,
    };
    this.handleDismiss = this.handleDismiss.bind(this);
  }

  handleChange = (e) => {
    if(e.target.value){
      this.setState({listenerarnError: ''});
    }
    this.setState({listenerarn : e.target.value});
  }

  handleInstall = () => {
    if(this.state.listenerarn){
      this.setState({disabled: true});
      this.props.userStatus({certificateArn: this.state.CertificateArn, listenerarn: this.state.listenerarn}, 'update-ssl')
    }else{
      this.setState({listenerarnError: 'red'});
    }
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  componentWillMount() {
    this.props.userList({page: 0}, 'import-ssl-list');
  }

  handleInstallSSLClose = () => {
    this.setState({ sslshow: false, siteID: '', certificate: '', privatekey: '', certificatechain: '', listenerarn: '' });
  }

  componentWillReceiveProps(nextProps) {
    console.log(nextProps)
    if(this.props.list != nextProps.list){
    	if(nextProps.list){
    		this.setState({sslList: nextProps.list});
    	}
    }

    if(this.props.status != nextProps.status){
    	if(nextProps.status){
    		this.handleShow();
        this.handleInstallSSLClose();
    		this.props.clearAlert();
        this.props.userList({page: 0}, 'import-ssl-list');
    		this.props.renderAlert("success", nextProps.status.data.message);
        window.scrollTo(0, 0);
    	}
    }

    if(this.props.error != nextProps.error){
      if(nextProps.error){
        this.handleShow();
        this.setState({disabled: false});
        this.props.userList({page: 0}, 'import-ssl-list');
        this.props.renderAlert("danger", nextProps.error);
        window.scrollTo(0, 0);
      }
    }

    if (nextProps.message) {
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }
  }

  installSSL = (CertificateArn) => {
    this.dialog.show({
      body: "Are you sure you want to install ssl?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.installProcess(CertificateArn);
          this.handleShow();
        })
      ]
    });
  }

  installProcess(CertificateArn){
    this.setState({sslshow: true, CertificateArn: CertificateArn, button_text: 'Install'});
  }

  render() {
    let from = this.state.from;
    const headerTitle = "SSL List";
    let superAdminList = [];

    if(!isEmpty(this.state.sslList)){
    	superAdminList = this.state.sslList.map((list, index) => (
    		<tr key={'list'+index}>
  			  <td>{++index}</td>
        	<td>{list.DomainName}</td>
        	<td><Button bsStyle="success" onClick={this.installSSL.bind(this, list.CertificateArn)}>Install SSL</Button></td>
         </tr>
    	));
    }
    return (
      <div className="col-xs-12 site-list">
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />

        <div className="row">
          <div className="col-xs-12">
            {this.state.show &&
              this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links}/>
          </div>
        </div>
        <div className="panel">
          <header className="panel-heading">Manage SSL</header>
          <div className="panel-body">
            <div className="col-lg-12">
              <table className="table table-hover" responsive="true">
                <thead>
                  <tr>
                    <th width="20%">S.No</th>
                    <th width="20%">Domain</th>
                    <th width="20%">Action</th>
                  </tr>
                </thead>
                <tbody>{superAdminList}</tbody>
              </table>
            </div>
          </div>
        </div>
        <Modal show={this.state.sslshow} onHide={this.handleInstallSSLClose}>
          <Modal.Header closeButton>
            <Modal.Title>Install SSL/TLS</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-12">
                <FormGroup controlId="formControlsSelect">
                  <ControlLabel>Load Balancer</ControlLabel>
                  <FormControl componentClass="select" onChange={this.handleChange} style={{borderColor : this.state.listenerarnError}} name="listenerarn" value={this.state.listenerarn} placeholder="select">
                    <option value="">Select Load Balancer</option>
                    <option value="arn:aws:elasticloadbalancing:us-east-1:094295440450:listener/app/payvibe/2cbd28b9c46972b9/ab9c2e5080fa6122">LB 01</option>
                    <option value="arn:aws:elasticloadbalancing:us-east-1:094295440450:listener/app/payvibe1/ac43428574b65b96/5efb87cc903eea58">LB 02</option>
                  </FormControl>
                </FormGroup>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="success" onClick={this.handleInstall} disabled={this.state.disabled}>{this.state.button_text}</Button>
            <Button onClick={this.handleInstallSSLClose}>Close</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
	error: state.user.error,
	list: state.user.list,
	status: state.user.status,
	alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
});


export default withRouter(connect(mapStateToProps, { userList, userStatus, renderAlert, clearAlert })(List));



// WEBPACK FOOTER //
// ./src/app/views/importSSL/List.js